import React, {useState, useEffect} from "react";
import { Container, Row, CustomInput, Button, Col, Modal, ModalBody, ModalFooter, Input } from "reactstrap";
import DocCards from './DocCards'
import {getDocs, userFiles} from 'network/ApiAxios'

const UserDocs = (props) => {
  const [docs, setdocs] = useState();
  const [file, setFile] = useState();
  const [show, setShow] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [fileName, setFileName] = useState();

  useEffect(() => {
    docArray()
    // eslint-disable-next-line
  }, [])
  const email = JSON.parse(localStorage.getItem("user")).email;

  const docArray = async () =>{
    const {data} = await getDocs(email);
    setdocs(data.files)
  }

  const upload = async () =>{
    setShow("")
    const formData = new FormData();
    formData.append("doc", file);
    formData.append("email", email);
    formData.append("fileName", fileName + "." + file.name.split(".")[file.name.split(".").length - 1]);
    const {data} = await userFiles(formData);
    if(data.success){
      setFile("")
      setShow("File Upload Successfull")
      docArray()
      setModalOpen(false)
    }else{
      setShow("Something went wrong!!!")
      setModalOpen(false)
    }
  }
    return (
      <>
        <Container fluid>
          <Row className="mt--4">
            <Col xl="8">
              <Input className="mb-3" id="file" type="file" onChange={(e) => setFile(e.target.files[0])}/>
            </Col>
            <Col xl="2" >
              <Button onClick={() => setModalOpen(true)} > Upload File </Button>
            </Col>

            <Col xl="2" >
              <strong> <label className="text-green"> {show} </label></strong>
            </Col>
              {docs ? docs.map((doc) =>{return (<DocCards key={doc} title={doc} link={doc} email={email}  />)}) : null}
          </Row>

          {/* change file name modal */}
          <Modal toggle={() => setModalOpen(!modalOpen)} isOpen={modalOpen}>
            <div className=" modal-header">
              <h5 className=" modal-title" id="exampleModalLabel">
                Choose a name for the file
              </h5>
            </div>
            <ModalBody>
              <Input
                className="form-control-alternative"
                id="input-country"             
                placeholder="File Name"             
                onChange={(e) => setFileName(e.target.value)}             
                type="text"           
              />                           
            </ModalBody>
            <ModalFooter>
              <Button
                color="secondary"
                type="button"
                onClick={() => setModalOpen(!modalOpen)}
              >
                Cancel
              </Button>
              <Button color="primary" type="button" onClick={upload}>
                Save changes
              </Button>
            </ModalFooter>
          </Modal>
        </Container>
      </>
    );
  
}

export default UserDocs;
